import { getItems } from '../../services/ItemService';
import { IFilter, IRootState } from '../types/IRootState';
import { ActionContext } from 'vuex';
import { isNameFilter } from '../isNameFilter';

import api from '@/services/api';
import { IPopulateCompanyFiltersPayload } from '../mutations/FilterMutations/CompanyFilterMutations';
import { IPopulateItemTypeFiltersPayload } from '../mutations/FilterMutations/ItemTypeFilterMutations';
import { IPopulateCategoryFiltersPayload } from '../mutations/FilterMutations/CategoryFilterMutations';

const itemActions = {
    fetchItems({ commit, getters, dispatch }: any, params: IFetchItemsAction) {
        commit('resetMaxItems');

        const preserveNameFilters = (params && params.preserveNameFilters != null)
            ? params.preserveNameFilters
            : true;

        if (params.generateFilters) {
            commit('cleanAttributeFilters', { preserveNameFilters });
            commit('cleanManufacturerFilters');
            commit('cleanCompanyFilters');
            commit('cleanItemTypeFilters');
        }
        const searchObject = buildSearchParams(getters, params);

        commit('setLoading', true);
        commit('setError', { status: 0, message: '' });
        getItems(searchObject)
            .then((response: any) => {

                commit('populateitemsState', response.products);
                commit('setItemsCounter', response.elasticSearchResponseCount);
                commit('hasEmptySearchResponse', response.elasticSearchResponseCount === 0);
                commit('resetMaxItems');

                if (params.generateFilters) {

                    commit('populateAttributeFilters', response.filters.attributes);
                    commit('populateManufacturerFilters', response.filters.partNumbers);
                    commit('populateCompanyFilters', response.filters.empresas);
                    commit('populateItemTypeFilters', response.filters.tipo);
                    commit('setHasFiltersFlag', true);
                }

                commit('setLoading', false);

            })
            .catch((error: any) => {
                commit('resetMaxItems');
                commit('clearItemsCounter');
                commit('cleanAttributeFilters', { preserveNameFilters });
                commit('cleanManufacturerFilters');
                commit('cleanCompanyFilters');
                commit('cleanItemTypeFilters');
                commit('clearItems');
                if (error.status) {
                    commit('setError', { status: error.response.status, message: error.response.statusText });
                } else {
                    commit('setError', { status: 400, message: 'sistema-desconectado' });
                }
                commit('setLoading', false);
            });
    },

    checkAttributeFilter({ commit, dispatch }: ActionContext<IRootState, IRootState>, { filter: { name, value } }: ICheckAttributeFilterPayload) {
        commit('checkFilter', { name, filterValue: value });

        const options: IFetchItemsAction = isNameFilter(name)
            ? { generateFilters: true, preserveNameFilters: true }
            : { generateFilters: false };

        dispatch('fetchItems', options);
    },

    buildCompanyFilters({ commit }: ActionContext<IRootState, IRootState>, newFilters: any) {
        const ids = Object.keys(newFilters).map(id => id);

        api.getCompanies(ids)
            .then(companies => commit('populateCompanyFilters', ({
                companies: companies.map(company => ({ ...company, count: newFilters[company.id] })),
            } as IPopulateCompanyFiltersPayload)));
    },
    checkCompanyFilter({ commit, dispatch }: ActionContext<IRootState, IRootState>, { id }: { id: string }) {
        commit('checkCompanyFilter', { id });
        dispatch('fetchItems', { generateFilters: false });
    },

    buildItemTypeFilters({ commit }: ActionContext<IRootState, IRootState>, newFilters: any) {
        const ids = Object.keys(newFilters).map(id => id);

        api.getItemTypes(ids)
            .then(itemTypes => commit('populateItemTypeFilters', ({
                itemTypes: itemTypes.map(({ id, description }) => ({ id, name: description, count: newFilters[id] })),
            } as IPopulateItemTypeFiltersPayload)));
    },
    checkItemTypeFilter({ commit, dispatch }: ActionContext<IRootState, IRootState>, { id }: { id: number }) {
        commit('checkItemTypeFilter', { id });
        dispatch('fetchItems', { generateFilters: false });
    },
    checkManufacturerFilter({ commit, dispatch }: ActionContext<IRootState, IRootState>, { id }: { id: string }) {
        commit('checkManufacturerFilter', { id });
        setTimeout(() => dispatch('fetchItems', { generateFilters: false }), 100);
    },
    buildCategoryFilters({ commit }: ActionContext<IRootState, IRootState>, newFilters: any) {
        const ids = Object.keys(newFilters).map(id => Number(id));

        api.getCategories(ids)
            .then(categories => commit('populateCategoryFilters', ({
                categories: categories.map(({ idCateg, descricao, idPai, grupo }) => (
                    {
                        id: idCateg,
                        name: descricao,
                        count: newFilters[idCateg],
                        parentId: idPai,
                        group: grupo,
                    }
                )),
            } as IPopulateCategoryFiltersPayload)));
    },
    checkCategoryFilter({ commit, dispatch }: ActionContext<IRootState, IRootState>, { id }: { id: number }) {
        commit('checkCategoryFilter', { id });
        dispatch('fetchItems', { generateFilters: false });
        document.querySelectorAll('#contentContainer').forEach(c => c.scrollIntoView());
    },
};

function buildSearchParams(getters: any, params: IFetchItemsAction) {
    const checkedFilters = getters.getCheckedFilters
        .map(({ type, name, value }: IFilter) => ({ type, name, value }));

    return {
        search: getters.getSearchString,
        searchType: getters.getCurrentSearchType.id,
        searchSize: params.searchSize,
        checkedFilters,
        generateFilters: params.generateFilters,
        language: getters.getGlobalLanguage,
        token: '',
    };
}

interface IFetchItemsAction {
    Search?: string;
    searchSize?: number;
    generateFilters: boolean;
    preserveNameFilters?: boolean;
}

interface ICheckAttributeFilterPayload {
    filter: {
        name: string;
        value: string;
    };
}

export default itemActions;
